import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import RoomHomePage from './components/RoomHomePage';
import TrustedRental from './components/TrustedRental';
import ImageManager from './components/ImageManager';
import CasesManager from './components/CasesManager';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQ7F4ujNvMhs_0n4GuxCExHjSSRGdMr08",
  authDomain: "totorent-a136f.firebaseapp.com",
  projectId: "totorent-a136f",
  storageBucket: "totorent-a136f.appspot.com",
  messagingSenderId: "843028553069",
  appId: "1:843028553069:web:b1edcdb93918ceae86ce64",
  measurementId: "G-93P6YLLQFV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/room" />} />
        <Route path="/room/" element={<HomePage />} />
        <Route path="/roomall/" element={<HomePage />} />
        <Route path="/room/:caseId" element={<RoomHomePage />} />
        <Route path="/awooadmin/image_manager" element={<ImageManager />} />
        <Route path="/awooadmin/cases_manager" element={<CasesManager />} />
        {/* <Route path="/trusted-rental" element={<TrustedRental />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
